import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import { countact_mail } from "../Actions/HelpAction"

const mapStateToProps = (state) => {
    return {
        helpRed: state.HelpReducer
    }
}

const mapDispatchToProps = dispatch => ({
    countact_mail: (data) => dispatch(countact_mail(data))
});


function getImageURL(data, type = "", url = "") {
    var image = ""

    switch (type) {
        case "banner":
            image = API_URL + "/" + data.banner_image
            break;
        case "one":
            image = API_URL + "/" + data.img_one
            break;
        case "two":
            image = API_URL + "/" + data.img_two
            break;
        case "three":
            image = API_URL + "/" + data.img_three
            break;
        case "url":
            image = API_URL + "/" + url
            break;

        default:
            break;
    }

    //     var path = data.home_image != "" ? data.home_image : data.image

    //     image = API_URL + "/" + path

    return image
}


class ContactUs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            phone: "",
            inquiry: "",
            message: "",
            disable: true
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentDidUpdate(prevProps) {
        // if (
        //     prevProps.reducer.custCare !== this.props.reducer.custCare &&
        //     this.props.reducer.custCare
        // ) {

        // }
    }

    submitForm = () => {
        var state = this.state
        this.props.countact_mail({
            name: state.name,
            email: state.email,
            phone: state.phone,
            inquiry: state.inquiry,
            message: state.message
        })
    }
    checkDisable = () => {
        var state = this.state
        if (state.name == "" || state.email == "" || state.phone == "" || state.inquiry == "" || state.message == "") {
            return false
        }
        this.setState({ disable: false })
    }

    handChange = (e) => {
        this.setState({ [e.target.name]: e.target.value }, () => this.checkDisable())
    }


    render() {
        var contact = this.props.helpRed.about
        return <Fragment>
            <Header Home={false} />

            <div id="main-container" className='contact-us-page'>

                <div className="contact-map-">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7987412519524!2d79.96979371402581!3d6.9146501204125865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2fede5553e6f9%3A0x35c92cdd713590a4!2s164+New+Kandy+Rd%2C+Weliweriya!5e0!3m2!1sen!2slk!4v1500636351507" width="100%" height="515" frameborder="0" style={{ border: 0 }} allowfullscreen></iframe>
                </div>

                <div className="page-content contact-us">
                    <div className="container">

                        <div className="row ">
                            <div className="contact-us-details col-lg-12">
                                <div className="contact-details-inner">
                                    <div className="contact-col address">
                                        <h4>Address</h4>
                                        <p>164/B, New Kandy Road, <br />
                                            Kothalawala,<br />
                                            Kaduwela, Sri Lanka</p>
                                    </div>

                                    <div className="contact-col general">
                                        <h4>General</h4>
                                        <p>Direct : +94 112 579 779<br />
                                            E Mail : info@beyondescapes.com<br />
                                            Skype : beyond.escapes</p>
                                    </div>

                                    <div className="contact-col bookings">
                                        <h4>Bookings</h4>
                                        <p>Hotline : +94 112 579 679<br />
                                            Direct : +94 112 579 779<br />
                                            E Mail : tours@beyondescapes.com</p>
                                    </div>contact-details-inner
                                    <div className="clear"></div>
                                </div>
                            </div>
                            <div className="clear"></div>
                        </div>

                        <div className="row contact-form-top">
                            <div className="contact-form col-lg-12">
                                <h2>Leave us your info</h2>
                                <br />
                            </div>
                        </div>
                        <div className="row contact-form-bottom">
                            <div className="col-lg-12">
                                <div className="contact-form-cont-inner">
                                    <div className="contact-form-cont">
                                        <label>Name</label>
                                        <input type="text" className="txt-contact" name="name" value={this.state.name} onChange={this.handChange} />
                                    </div>
                                    <div className="contact-form-cont">
                                        <label>Email</label>
                                        <input type="text" className="txt-contact" name="email" value={this.state.email} onChange={this.handChange} />
                                    </div>
                                    <div className="contact-form-cont">
                                        <label>Phone</label>
                                        <input type="text" className="txt-contact" name="phone" value={this.state.phone} onChange={this.handChange} />
                                    </div>
                                    <div className="contact-form-cont">
                                        <label>Inquiry</label>
                                        <input type="text" className="txt-contact" name="inquiry" value={this.state.inquiry} onChange={this.handChange} />
                                    </div>
                                    <div className="contact-form-cont txtarea-messages">
                                        <label>Message</label>
                                        <textarea className="txtarea-contact" name="message" value={this.state.message} onChange={this.handChange} ></textarea>
                                    </div>

                                    <button disabled={this.state.disable} onClick={this.submitForm} type="submit" className="button btn-blue pull-right btn-arrow-next btn-send-inquiry">Submit Inquiry
                                        <span className="bi bi-chevron-right"></span></button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>


            <Footer hyperLink={false}/>

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ContactUs);